module.exports = __webpack_public_path__ + "static/img/pay-en-1.94c28f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/en/pay-en-1.png
// module id = Ug3R
// module chunks = 0